import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
  getInputClassName,
} from './StandardInputStyles';

interface Option {
  value: string;
  label?: string;
}

interface Props extends Omit<StandardInputBaseProps, 'value' | 'placeholderText' | 'label'> {
  label?: string;
  options: Option[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  inputClassName?: string; // extra classes applied to the <select>
}

export default function StandardInputSelect({
  id,
  label,
  isRequired,
  options,
  value,
  onChange,
  disabled = false,
  inputClassName,
}: Props) {
  return (
    <div className={inputContainerStyles}>
      {label && (
        <label htmlFor={id} className={labelStyles}>
          {label}
          {isRequired && <span className={requiredIndicatorStyles}>*</span>}
        </label>
      )}
      <select
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`${getInputClassName('select')} ${inputClassName ?? ''}`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
